import React from 'react'
import { useTranslation } from "react-i18next";

const ViewCatalogLocationGenericRelation = ({ values, values2, field, moduleText, occupation = 6 }) => {
    const { t } = useTranslation();

    return (
        <div className={`col-md-${occupation} viewContentGroup`}>
            <label htmlFor={field} className="tit-view-view tit-content-view-view">
                {t(`${moduleText}.synthetic.${field}`)}
            </label>
            <div
                className="txt-view viewContentTxt"
                aria-label="empty textarea"
                name={field}
                id={field}
            >
            {values[values2] && values[values2].name || ""}
            </div>
        </div>
    )
}

export default ViewCatalogLocationGenericRelation